import { render, staticRenderFns } from "./Patentstatistical.vue?vue&type=template&id=045ba7e3&scoped=true&"
import script from "./Patentstatistical.vue?vue&type=script&lang=js&"
export * from "./Patentstatistical.vue?vue&type=script&lang=js&"
import style0 from "./Patentstatistical.vue?vue&type=style&index=0&id=045ba7e3&scoped=true&lang=css&"
import style1 from "./Patentstatistical.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045ba7e3",
  null
  
)

export default component.exports